<template>
    <div class="producer-progress-icons">
        <svg-vue icon="setting-edit-filter-gear-square-1" class="icon" :class="{ 'success' : producerStatus > 0}" :title="this.$gettext('Produktion gestartet')" v-tippy="{content: this.$gettext('Produktion gestartet')}" />
        <svg-vue icon="shield-protection-square" class="icon" :class="{ 'success' : producerStatus > 1}" :title="this.$gettext('Qualitätskontrolle')" v-tippy="{content: this.$gettext('Qualitätskontrolle')}" />
        <svg-vue icon="box-delivery-package-car-pin-location-group" class="icon" :class="{ 'success' : producerStatus === 2}" :title="this.$gettext('Verschickt an PartFactory')" v-tippy="{content: this.$gettext('Verschickt an PartFactory')}" />
    </div>
</template>

<script>
export default {
    name: 'ProductionProgressIcons',
    props: {
        producerStatus: Number,
    },
};
</script>
